
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/video",
      function () {
        return require("private-next-pages/page/[subdomain]/video.tsx");
      }
    ]);
  